import { BusinessUnitModel } from 'types/BusinessUnit/BusinessUnitModel';
import { Option } from 'types/Form/FormCommons';

export const mapBusinessUnitToFilterOptions = (businessUnits: BusinessUnitModel[]): Option<number>[] =>
  businessUnits.map(({ id, name }) => ({
    label: name,
    value: id,
  }));
